/* eslint-disable */
export const settings = {
	app: {
		name: 'haeppy app',
		version: '0.0.5'
	},
	theme: {
		skin: 'light' // possible values are light, dark
	}
};
export default { settings };
